import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CommonTextField from "../../../common/components/functional/commonTextField/CommonTextField";
import FormGridRow from "../../../common/components/functional/formGridRow/FormGridRow";
import { VALID_EMAIL_REGEX } from "../../../common/helpers/regexes";
import { DeliveryMethod } from "../types/queries";
import { HelperText } from "./styles";
import { CustomerOrganizationForm } from "./types";

const InvoiceInfoAdditionalFields = () => {
  const { t } = useTranslation();

  const {
    control,
    watch,
    formState: { errors },
    clearErrors,
  } = useFormContext<CustomerOrganizationForm>();

  const selectedInvoiceDeliveryMethod: DeliveryMethod = watch(
    "invoiceSettings.deliveryMethod",
  );

  useEffect(() => {
    clearErrors();
    // FIXME: fix this or add comment why this is needed
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedInvoiceDeliveryMethod]);

  const fields = {
    [DeliveryMethod.BY_EMAIL]: (
      <>
        <FormGridRow
          label={t("common:emailAddress")}
          labelSize={2.8}
          fieldSize={9.2}
        >
          <Controller
            control={control}
            rules={{
              required: true,
              pattern: {
                value: VALID_EMAIL_REGEX,
                message: t("customers:usersNS:invalidEmail"),
              },
            }}
            name="invoiceSettings.emailAddress"
            render={({ field }) => (
              <CommonTextField
                {...field}
                sx={{ maxWidth: "372px" }}
                fullWidth
                size="small"
                error={!!errors.invoiceSettings?.emailAddress}
              />
            )}
          />
        </FormGridRow>
      </>
    ),
    [DeliveryMethod.BY_E_INVOICE]: (
      <>
        <FormGridRow
          label={t("customers:companyInfo.finvoiceAddress")}
          labelSize={2.8}
          fieldSize={9.2}
        >
          {/* TODO: this should be possible just by using FormGridRow */}
          <Box display="flex" gap="16px">
            <Controller
              name="invoiceSettings.address"
              rules={{ required: true }}
              render={({ field }) => (
                <CommonTextField
                  {...field}
                  sx={{ width: "203px" }}
                  size="small"
                  error={!!errors.invoiceSettings?.address}
                />
              )}
            />
            <Box display="flex" gap="8px" alignItems="center">
              <Typography variant="secondary">
                {t("customers:companyInfo.operatorId")}
              </Typography>
              <Controller
                name="invoiceSettings.operatorId"
                rules={{ required: true }}
                render={({ field }) => (
                  <CommonTextField
                    {...field}
                    sx={{ width: "203px" }}
                    size="small"
                    error={!!errors.invoiceSettings?.operatorId}
                  />
                )}
              />
            </Box>
          </Box>
        </FormGridRow>
      </>
    ),
    [DeliveryMethod.BY_OPERATOR]: (
      <>
        <FormGridRow labelSize={2.8} fieldSize={9.2}>
          <HelperText color="textSecondary">
            {t("customers:companyInfo:invoiceDeliveryHelperText")}
          </HelperText>
        </FormGridRow>
      </>
    ),
  };

  return fields[selectedInvoiceDeliveryMethod] || null;
};

export default InvoiceInfoAdditionalFields;
